/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import type { AxiosReturn, AxiosOptions } from '../types/return.types';

const getRequestOptions = ({
  method,
  url,
  isMultipart,
  token,
  body,
  responseType,
}: {
  method: any;
  url: string;
  isMultipart: boolean;
  token?: string;
  body: any;
  responseType?: 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream';
}) => {
  const options: AxiosOptions = {
    method,
    url,
    mode: 'cors',
    credentials: 'true',
    withCredentials: true,
    headers: {
      'Content-Type': isMultipart ? 'multipart/form-data' : 'application/json',
      'Cache-Control': 'no-store, max-age=0',
      Authorization: token,
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    data: undefined,
    responseType: responseType,
  };

  if (body && method !== 'GET') {
    options.data = !isMultipart ? JSON.stringify(body) : body;
  }
  return options;
};

/**
 * Wrapper function for making request
 * @param { Object } params Object containing key/value parameters to pass axios request()
 * @returns {Promise<null|any>}
 */

export const request = async ({
  url,
  method = 'GET',
  body,
  token,
  isMultipart = false,
  responseType,
}: {
  method: any;
  url: string;
  isMultipart?: boolean;
  token?: string;
  body: any;
  responseType?: 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream';
}) => {
  const requestOptions: AxiosOptions = getRequestOptions({
    method,
    url,
    isMultipart,
    body,
    token,
    responseType,
  });
  if (isMultipart) {
    requestOptions.headers['Content-Type'] = 'multipart/form-data';
  }
  try {
    const response: AxiosReturn = await axios.request(requestOptions);

    if (!response.error) {
      return response;
    }
    return null;
  } catch (error) {
    console.error('REQUEST ERROR ', error);
    throw error;
  }
};

export const multipartRequest = async ({
  url,
  method = 'POST',
  body,
  token,
  responseType,
}: {
  method: any;
  url: string;
  token?: string;
  body: any;
  responseType?: 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream';
}) =>
  request({
    url,
    method,
    body,
    token,
    isMultipart: true,
    responseType,
  });
